import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError(false);
    api
      .get(`/blog/${slug}`)
      .then(({ data }) => setPost(data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="pt-40 pb-28 flex justify-center">
        <Loader2 className="h-8 w-8 text-gold animate-spin" />
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="pt-40 pb-28 text-center px-4">
        <p className="text-smoke">Post not found.</p>
        <Link to="/blog" className="text-gold underline mt-4 inline-block" data-testid="blog-post-back-link">
          Back to Blog
        </Link>
      </div>
    );
  }

  return (
    <article className="pt-28 sm:pt-36 pb-20 sm:pb-28 max-w-3xl mx-auto px-4 sm:px-6" data-testid="blog-post-article">
      <Reveal>
        <Link to="/blog" className="inline-flex items-center gap-2 text-gold text-sm uppercase tracking-wider mb-8" data-testid="blog-post-back-arrow">
          <ArrowLeft className="h-4 w-4" /> All Posts
        </Link>
        <span className="text-xs uppercase tracking-widest text-gold">{post.category}</span>
        <h1 className="font-anton uppercase tracking-tighter text-cream text-3xl sm:text-5xl mt-3">{post.title}</h1>
        <p className="text-smoke text-sm mt-4">By {post.author}</p>
        <img
          src={post.image}
          alt={post.title}
          style={post.slug === "why-elysium-exists" ? undefined : { objectPosition: "50% 15%" }}
          className={`w-full h-64 sm:h-96 border border-line mt-8 bg-surface ${
            post.slug === "why-elysium-exists" ? "object-contain" : "object-cover"
          }`}
        />
        <p className="text-cream/90 leading-relaxed text-base sm:text-lg mt-8 whitespace-pre-line">{post.content}</p>
      </Reveal>
    </article>
  );
}
